// Транспортный конверт и служебные сообщения.
//
// Это единственный источник правды о протоколе. Go и TypeScript получают
// свои типы отсюда генерацией — руками структуры сообщений не пишутся
// ни с одной стороны.
//
// Сообщения сцены и операции лежат в соседних файлах:
// scene.proto и ops.proto.
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_owm_v1_ops } from "./ops_pb.js";
import { file_owm_v1_scene } from "./scene_pb.js";
/**
 * Describes the file owm/v1/envelope.proto.
 */
export const file_owm_v1_envelope = /*@__PURE__*/ fileDesc("ChVvd20vdjEvZW52ZWxvcGUucHJvdG8SBm93bS52MSIuCgxDYXBhYmlsaXRpZXMSDgoGYmluYXJ5GAEgASgIEg4KBmNvZGVjcxgCIAMoCSKjAQoFSGVsbG8SEgoKY2hhbm5lbF9pZBgBIAEoCRInCgtjbGllbnRfa2luZBgCIAEoDjISLm93bS52MS5DbGllbnRLaW5kEg0KBXRva2VuGAMgASgJEhkKDGxhc3RfdmVyc2lvbhgEIAEoBEgAiAEBEiIKBGNhcHMYBSABKAsyFC5vd20udjEuQ2FwYWJpbGl0aWVzQg8KDV9sYXN0X3ZlcnNpb24iRQoHV2VsY29tZRIRCgljbGllbnRfaWQYASABKAkSFgoOc2VydmVyX3RpbWVfbXMYAiABKAMSDwoHdmVyc2lvbhgDIAEoBCIVCgRQaW5nEg0KBXRzX21zGAEgASgDIisKBFBvbmcSDQoFdHNfbXMYASABKAMSFAoMc2VydmVyX3RzX21zGAIgASgDIkQKBUVycm9yEgwKBGNvZGUYASABKAkSDwoHbWVzc2FnZRgCIAEoCRISCgVvcF9pZBgDIAEoCUgAiAEBQggKBl9vcF9pZCI5CghTbmFwc2hvdBIPCgd2ZXJzaW9uGAEgASgEEhwKBXNjZW5lGAIgASgLMg0ub3dtLnYxLlNjZW5lImsKBVBhdGNoEg8KB3ZlcnNpb24YASABKAQSEAoIc2NlbmVfaWQYAiABKAkSFwoDb3BzGAMgAygLMgoub3dtLnYxLk9wEhcKCmJ5X3VzZXJfaWQYBCABKAlIAIgBAUINCgtfYnlfdXNlcl9pZCJhCgRMaXZlEhAKCGxheWVyX2lkGAEgASgJEiQKCXRyYW5zZm9ybRgCIAEoCzIRLm93bS52MS5UcmFuc2Zvcm0SIQoGbGF5ZXJzGAMgAygLMhEub3dtLnYxLkxpdmVMYXllciJDCglMaXZlTGF5ZXISEAoIbGF5ZXJfaWQYASABKAkSJAoJdHJhbnNmb3JtGAIgASgLMhEub3dtLnYxLlRyYW5zZm9ybSJXCgZTa2V0Y2gSEQoJY2xpZW50X2lkGAEgASgJEgwKBGtpbmQYAiABKAkSDgoGcG9pbnRzGAMgAygBEg0KBWNvbG9yGAQgASgJEg0KBXdpZHRoGAUgASgBIuACCghFbnZlbG9wZRIeCgVoZWxsbxgBIAEoCzINLm93bS52MS5IZWxsb0gAEiIKB3dlbGNvbWUYAiABKAsyDy5vd20udjEuV2VsY29tZUgAEhwKBHBpbmcYAyABKAsyDC5vd20udjEuUGluZ0gAEhwKBHBvbmcYBCABKAsyDC5vd20udjEuUG9uZ0gAEh4KBWVycm9yGAUgASgLMg0ub3dtLnYxLkVycm9ySAASIwoIb3BfYmF0Y2gYBiABKAsyDy5vd20udjEuT3BCYXRjaEgAEiQKCHNuYXBzaG90GAcgASgLMhAub3dtLnYxLlNuYXBzaG90SAASHgoFcGF0Y2gYCCABKAsyDS5vd20udjEuUGF0Y2hIABIcCgRsaXZlGAkgASgLMgwub3dtLnYxLkxpdmVIABIgCgZza2V0Y2gYCiABKAsyDi5vd20udjEuU2tldGNoSABCCQoHcGF5bG9hZCpwCgpDbGllbnRLaW5kEhsKF0NMSUVOVF9LSU5EX1VOU1BFQ0lGSUVEEAASFQoRQ0xJRU5UX0tJTkRfUEFORUwQARIXChNDTElFTlRfS0lORF9PVkVSTEFZEAISFQoRQ0xJRU5UX0tJTkRfQUdFTlQQA0IbWhlvd20vcHJvdG9jb2wvb3dtL3YxO293bXYxYgZwcm90bzM", [file_owm_v1_ops, file_owm_v1_scene]);
/**
 * Describes the message owm.v1.Capabilities.
 * Use `create(CapabilitiesSchema)` to create a new message.
 */
export const CapabilitiesSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 0);
/**
 * Describes the message owm.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 1);
/**
 * Describes the message owm.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 2);
/**
 * Describes the message owm.v1.Ping.
 * Use `create(PingSchema)` to create a new message.
 */
export const PingSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 3);
/**
 * Describes the message owm.v1.Pong.
 * Use `create(PongSchema)` to create a new message.
 */
export const PongSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 4);
/**
 * Describes the message owm.v1.Error.
 * Use `create(ErrorSchema)` to create a new message.
 */
export const ErrorSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 5);
/**
 * Describes the message owm.v1.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 6);
/**
 * Describes the message owm.v1.Patch.
 * Use `create(PatchSchema)` to create a new message.
 */
export const PatchSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 7);
/**
 * Describes the message owm.v1.Live.
 * Use `create(LiveSchema)` to create a new message.
 */
export const LiveSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 8);
/**
 * Describes the message owm.v1.LiveLayer.
 * Use `create(LiveLayerSchema)` to create a new message.
 */
export const LiveLayerSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 9);
/**
 * Describes the message owm.v1.Sketch.
 * Use `create(SketchSchema)` to create a new message.
 */
export const SketchSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 10);
/**
 * Describes the message owm.v1.Envelope.
 * Use `create(EnvelopeSchema)` to create a new message.
 */
export const EnvelopeSchema = /*@__PURE__*/ messageDesc(file_owm_v1_envelope, 11);
/**
 * Кто подключился. От этого зависит и способ аутентификации,
 * и что клиенту разрешено отправлять.
 *
 * @generated from enum owm.v1.ClientKind
 */
export var ClientKind;
(function (ClientKind) {
    /**
     * @generated from enum value: CLIENT_KIND_UNSPECIFIED = 0;
     */
    ClientKind[ClientKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Панель модератора: аутентификация по сессионной куке + проверка Origin.
     *
     * @generated from enum value: CLIENT_KIND_PANEL = 1;
     */
    ClientKind[ClientKind["PANEL"] = 1] = "PANEL";
    /**
     * Оверлей в OBS: аутентификация по overlay-токену, права только на чтение.
     *
     * @generated from enum value: CLIENT_KIND_OVERLAY = 2;
     */
    ClientKind[ClientKind["OVERLAY"] = 2] = "OVERLAY";
    /**
     * Мост к obs-websocket. Вне основного плана, см. docs/06.
     *
     * @generated from enum value: CLIENT_KIND_AGENT = 3;
     */
    ClientKind[ClientKind["AGENT"] = 3] = "AGENT";
})(ClientKind || (ClientKind = {}));
/**
 * Describes the enum owm.v1.ClientKind.
 */
export const ClientKindSchema = /*@__PURE__*/ enumDesc(file_owm_v1_envelope, 0);
//# sourceMappingURL=envelope_pb.js.map